











import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import _ from 'lodash';
import SectionWithListVue from '@/components/SectionWithList.vue';
import { skills } from '@/data';
import { ISkillSet } from '@/@types';
import { UseFluid } from '@/mixins/UseFluid';

const personaModule = namespace('persona');

@Component({
  components: {
    SectionWithListVue,
  },
})
export default class Skills extends Mixins(UseFluid) {
  @personaModule.Getter('skills') public skills!: ISkillSet[];
  public startCase = _.startCase;
}
